var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 588,
    viewBox: "0 0 588 588",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.855 41.6956C323.85 28.6348 426.47 -16.7014 507.5 7.50004C585.11 30.68 591.576 52.0167 586 127C580.082 206.566 557.238 198.639 538.5 276.5C522.182 344.304 566.664 476.078 538.5 540.5C513.059 598.692 344.624 557 272 557C210.307 567.396 162.5 595.5 91.5 586C29.5 572.5 22.0898 562.597 4.50004 511C-10.4999 467 16 394.5 29.5 340.5C35.5 295.5 38.5001 271 32.0001 227C23.2103 167.5 -4.27718 68.2226 49.2543 33.7755C102.47 -0.46841 175.848 51.6485 239.855 41.6956Z",
    fill: "#F3E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob2);
export default __webpack_public_path__ + "static/media/Blob2.6365d30e3edcc2e3bd865b90cebd2e20.svg";
export { ForwardRef as ReactComponent };